/**
 * @file Automatically generated by barrelsby.
 */

export * from './announcements-popup.component';
